<template>
  <Poi />
</template>

<script>
import Poi from "../Area/Map/Map.vue";
import { mapState } from "vuex";
export default {
  components: {
    Poi,
  },

  computed: {
    ...mapState({
      currentRoute: (state) => state.routes.currentRoute,
    }),
  },
};
</script>

<style scoped lang="scss">
</style>